import {
  Text as ReactAriaText,
  UNSTABLE_Toast as ReactAriaToast,
  UNSTABLE_ToastContent as ReactAriaToastContent,
  UNSTABLE_ToastQueue as ReactAriaToastQueue,
  UNSTABLE_ToastRegion as ReactAriaToastRegion,
} from 'react-aria-components/Toast';
import { flushSync } from 'react-dom';

import css from './Toast.css';

const MAX_VISIBLE_TOASTS = 3;

/** Auto-dismiss delay. Long enough to read a sentence; the timer pauses while the region is hovered or focused. */
const TOAST_TIMEOUT_MS = 5000;

const toasts = new ReactAriaToastQueue<string>({
  maxVisibleToasts: MAX_VISIBLE_TOASTS,
  /**
   * A toast does not animate itself in and out — it has no entering or exiting state to style — so
   * react-aria animates the queue's updates with a view transition instead, which `Toast.css` picks
   * up through `view-transition-class`. `flushSync` is what puts React's update inside it.
   */
  wrapUpdate: (update) => {
    if ('startViewTransition' in document) {
      document.startViewTransition(() => flushSync(update));
    } else {
      update();
    }
  },
});

export const ToastRegion = () => {
  return (
    <ReactAriaToastRegion queue={toasts} className={css.region}>
      {({ toast }) => (
        // Each toast needs a transition name of its own, or they animate as one element.
        <ReactAriaToast toast={toast} className={css.toast} style={{ viewTransitionName: toast.key }}>
          <ReactAriaToastContent className={css.content}>
            <ReactAriaText slot="title">{toast.content}</ReactAriaText>
          </ReactAriaToastContent>
        </ReactAriaToast>
      )}
    </ReactAriaToastRegion>
  );
};

export function showToast(message: string): void {
  toasts.add(message, { timeout: TOAST_TIMEOUT_MS });
}
